import { Injectable } from "@angular/core";
import { BehaviorSubject, EMPTY, Subject } from "rxjs";
import { EMPTY_PATIENT_PAGE_MODEL, PatientModel, PatientPageModel } from "../../global-data-models/patient.model";
import { DEFAULT_PATIENT_PAGE_OPTIONS, OrderDir, PatientService } from "../../global-services/patient.service";
import { GlobalMessageService } from "../../global-services/global-message.service";
import { GlobalLoadingService } from "../../global-services/global-loading.service";
import { PatientPageOptions } from "../../global-services/patient.service";

export interface PatientsViewUiState {
    patientPage:    PatientPageModel;
}

const EMPTY_PATIENTS_VIEW_UI_STATE: PatientsViewUiState = { patientPage: EMPTY_PATIENT_PAGE_MODEL };

@Injectable({ providedIn: 'root' })
export class PatientsViewFacade {
    private uiState: PatientsViewUiState    = EMPTY_PATIENTS_VIEW_UI_STATE;
    private readonly _uiState$              = new BehaviorSubject<PatientsViewUiState>(this.uiState);
    public readonly uiState$                = this._uiState$.asObservable();
    private readonly destroy$ = new Subject<void>();

    private pageOptions: PatientPageOptions = DEFAULT_PATIENT_PAGE_OPTIONS;

    public constructor(
        private readonly patientService: PatientService,
        private readonly messageService: GlobalMessageService,
        private readonly loadingService: GlobalLoadingService
    ) {}
    
    public async loadPatients(): Promise<void> {
        this.loadingService.show();
        try {
            const _patientPage: PatientPageModel = await this.patientService.getPatientsPage(this.pageOptions);
            this._uiState$.next({ patientPage: _patientPage });
        } catch (error: Error | any) {
            // Handle error (e.g., show message via message service)
            this._uiState$.next(EMPTY_PATIENTS_VIEW_UI_STATE);
            this.messageService.showError("Get Patients Error", error.message);
        } finally {
            this.loadingService.hide();
        }
    }

    public setPatientPageOptions(pageOptions: PatientPageOptions) { this.pageOptions = pageOptions; }
    // public getPatientPageOptions(): PatientPageOptions { return this.pageOptions; }

    public destroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
